// extracted by mini-css-extract-plugin
export default {"needSolutionSection":"needsolution_needSolutionSection__gxocI","needSolutionContainer":"needsolution_needSolutionContainer__DL3Ge"};